import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const UnpaidBillsManager = lazy(() => import('./UnpaidBillsManager'));

export const unpaidBillsRoutes: RouteObject[] = [
  {
    path: 'unpaid-bills',
    element: <UnpaidBillsManager />,
  },
];
